/**
 * swym-tax-multiplier.js
 * - Swym Wishlist drawer 内の価格表示を「税抜→税込 (x1.1, round)」に変換
 * - final price / compare price の両方に適用
 * - (税込) 表示は final price の横だけに付与（compare-price には付与しない）
 *
 * 仕様:
 * Liquidの例: {{ amount | times: 1.1 | round | money }}
 * → JSでも Math.round(amount * 1.1) を採用
 */
(function () {
  "use strict";

  const TAX_MULTIPLIER = 1.1;

  // 価格表示の対象（税計算自体は両方に適用）
  const PRICE_SELECTORS = [
    ".swym-storefront-layout-grid-item-final-price",
    ".swym-storefront-layout-grid-item-compare-price",
  ];

  // (税込) を付けるのは final のみ
  const TAX_LABEL_TARGET_SELECTOR = ".swym-storefront-layout-grid-item-final-price";

  // MutationObserver を間引く
  let rafId = null;

  /** "¥1,980" -> 1980 */
  function parseJPY(text) {
    if (!text) return null;
    const n = String(text).replace(/[^\d]/g, "");
    return n ? Number(n) : null;
  }

  /** 1980 -> "¥1,980"（moneyFormat があれば利用） */
  function formatJPY(amount) {
    const fmt =
      (window.theme &&
        window.theme.settings &&
        typeof window.theme.settings.moneyFormat === "string" &&
        window.theme.settings.moneyFormat) ||
      "¥{{amount}}";

    const withComma = Math.round(amount)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (fmt.includes("{{amount}}")) return fmt.replace("{{amount}}", withComma);
    if (fmt.includes("{{amount_no_decimals}}"))
      return fmt.replace("{{amount_no_decimals}}", withComma);

    // フォールバック
    return `¥${withComma}`;
  }

  /** Liquid: times:1.1 | round に合わせる */
  function applyTaxAndRound(jpyInt) {
    return Math.round(jpyInt * TAX_MULTIPLIER);
  }

  /** (税込) ラベル作成（価格と同じ色・0.9em） */
  function buildTaxLabel(priceEl) {
    const label = document.createElement("span");
    label.className = "swym-tax-label";
    label.textContent = "(税込)";

    // 価格色をそのまま採用（変数指定でも確実に一致）
    const priceColor = priceEl ? getComputedStyle(priceEl).color : "";

    label.style.fontSize = "0.9em";
    label.style.marginLeft = "4px";
    label.style.whiteSpace = "nowrap";
    if (priceColor) label.style.color = priceColor;

    return label;
  }

  /** final price の右にだけ (税込) を挿入/更新 */
  function upsertTaxLabelForFinal(priceEl) {
    if (!priceEl) return;

    // compare-price には絶対付けない
    if (priceEl.classList.contains("swym-storefront-layout-grid-item-compare-price")) return;

    const next = priceEl.nextElementSibling;

    // 既にあるなら、色やサイズだけ同期して終了
    if (next && next.classList.contains("swym-tax-label")) {
      const priceColor = getComputedStyle(priceEl).color;
      next.style.fontSize = "0.9em";
      next.style.marginLeft = "4px";
      next.style.whiteSpace = "nowrap";
      if (priceColor) next.style.color = priceColor;
      return;
    }

    // 無ければ新規追加
    const label = buildTaxLabel(priceEl);
    priceEl.insertAdjacentElement("afterend", label);
  }

  /** compare-price 側に付いてしまった (税込) を掃除（方針変更の後方互換） */
  function removeTaxLabelIfNextToCompare(compareEl) {
    if (!compareEl) return;
    const next = compareEl.nextElementSibling;
    if (next && next.classList.contains("swym-tax-label")) next.remove();
  }

  /** 1要素を更新（税計算 + 表示更新） */
  function updatePriceEl(el) {
    if (!el) return;

    // 元値を保持（すでに tax 済みの textContent から再計算しない）
    const original =
      el.getAttribute("data-original-price") || (el.textContent || "").trim();

    const n = parseJPY(original);
    if (n == null) return;

    if (!el.getAttribute("data-original-price")) {
      el.setAttribute("data-original-price", original);
    }

    const taxed = applyTaxAndRound(n);
    el.textContent = formatJPY(taxed);

    // compare-price の横に付いてしまった (税込) は消す
    if (el.classList.contains("swym-storefront-layout-grid-item-compare-price")) {
      removeTaxLabelIfNextToCompare(el);
    }
  }

  /** 対象全て更新 */
  function updateAll() {
    // 税計算は final / compare 両方
    PRICE_SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach(updatePriceEl);
    });

    // (税込) は final のみ付与
    document
      .querySelectorAll(TAX_LABEL_TARGET_SELECTOR)
      .forEach(upsertTaxLabelForFinal);

    // 念のため compare 側の誤付与を一括掃除
    document
      .querySelectorAll(".swym-storefront-layout-grid-item-compare-price")
      .forEach(removeTaxLabelIfNextToCompare);
  }

  /** rAFで間引き */
  function scheduleUpdate() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateAll();
    });
  }

  /** 初回実行 */
  updateAll();

  /** Swym の描画差し替えに追従 */
  const mo = new MutationObserver(() => scheduleUpdate());
  mo.observe(document.body, { childList: true, subtree: true });

  /** Swymがイベントを出している場合にも追従（安全に追加） */
  window.addEventListener("swym:wishlist:loaded", scheduleUpdate);
  window.addEventListener("swym:rendered", scheduleUpdate);
})();
